// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"84":"2cece2d274ae5b8383d0","653":"e07ff7a4e980dafd9443"}[chunkId] + ".js";
};